import { getAuthHeaders } from '../../utils/token';
import { api } from '../Users/user';

const BASE_URL = api + '/api/appointments';

export type AppointmentStatus = 'PENDIENTE' | 'CONFIRMADA' | 'COMPLETADA' | 'CANCELADA';

export type AppointmentType =
  | 'CONSULTA'
  | 'RAYOS X'
  | 'TOMOGRAFIA'
  | 'RESONANCIA'
  | 'ULTRASONIDO'
  | 'MAMOGRAFIA'
  | 'SEGUIMIENTO';

export interface AppointmentAPI {
  _id: string;
  patientIdCode: string; // Código del paciente
  date: string; // Fecha y hora de la cita (ISO string)
  reason: string;
  type: AppointmentType;
  status: AppointmentStatus;
  notes?: string;
  patient: {
    // Datos del paciente poblado
    _id: string;
    firstName: string;
    lastName: string;
    patientId: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface AppointmentData {
  patientIdCode: string;
  date: string; // Fecha y hora
  reason: string;
  type: AppointmentType;
  status?: AppointmentStatus;
  notes?: string;
}

// --- Función de Utilidad para Fetch con Manejo de Errores (asumimos que ya existe) ---
// La reutilizamos de tu ejemplo anterior
async function apiFetch<T>(url: string, options: RequestInit): Promise<T> {
  const defaultHeaders = getAuthHeaders();
  options.headers = {
    ...defaultHeaders,
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const response = await fetch(url, options);

  const data = await response
    .json()
    .catch(() => ({ message: response.statusText || 'Error desconocido' }));

  if (!response.ok) {
    throw new Error(data.message || `La petición falló con status ${response.status}`);
  }

  return data as T;
}

/**
 * Obtiene la lista de todas las citas.
 */
export function fetchAllAppointments(): Promise<AppointmentAPI[]> {
  return apiFetch<AppointmentAPI[]>(BASE_URL, {
    method: 'GET',
  });
}

/**
 * Crea una nueva cita.
 */
export function createAppointment(appointmentData: AppointmentData): Promise<AppointmentAPI> {
  return apiFetch<AppointmentAPI>(BASE_URL, {
    method: 'POST',
    body: JSON.stringify(appointmentData),
  });
}

/**
 * Obtiene citas por Patient ID (código ingresado por el usuario).
 */
export function fetchAppointmentsByPatientCode(patientIdCode: string): Promise<AppointmentAPI[]> {
  return apiFetch<AppointmentAPI[]>(`${BASE_URL}/patient/${patientIdCode}`, {
    method: 'GET',
  });
}

/**
 * Actualiza parcialmente una cita existente.
 */
export function updateAppointment(
  id: string,
  appointmentData: Partial<AppointmentData>
): Promise<AppointmentAPI> {
  return apiFetch<AppointmentAPI>(`${BASE_URL}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(appointmentData),
  });
}

/**
 * Elimina una cita por su ID.
 */
export function deleteAppointment(id: string): Promise<void> {
  return apiFetch<void>(`${BASE_URL}/${id}`, {
    method: 'DELETE',
  });
}
